import { ExtractRouteParams } from "@CommonUtils/routes";

export const RouteGetMerchflows_MerchflowId_Stores_StoreCode_ProductSyncLogDownloadUrl =
  "/merchflows/:merchflowId/stores/:storeCode/product-sync-log/download-url";

export type ParamsGetMerchflows_MerchflowId_Stores_StoreCode_ProductSyncLogDownloadUrl =
  ExtractRouteParams<
    typeof RouteGetMerchflows_MerchflowId_Stores_StoreCode_ProductSyncLogDownloadUrl
  >;

export interface ResponseGetMerchflows_MerchflowId_Stores_StoreCode_ProductSyncLogDownloadUrl {
  url: string;
}
